import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'scheduler/preview/custom-page-style';

export interface ISchedulerPreviewCustomPageStyle {
	hasCustomization: boolean;
	html?: string;
}

export function useSchedulerPreviewCustomPageStyleQuery({
	type,
	impersonationContext,
	enabled = true,
}: {
	type: Api.CustomPageType.Header | Api.CustomPageType.Footer;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		meta: {
			toastErrorMessage: 'Failed to load part of the meeting page preview',
		},
		queryFn: () =>
			new Promise<ISchedulerPreviewCustomPageStyle>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceRawResponse(
					Api.ImpersonationBroker.composeApiUrl({
						impersonationContext,
						urlPath: `scheduler/preview/custom-page-style/${type}`,
					}),
					'GET',
					null,
					async response => {
						const html = await response.text();
						resolve(html?.trim() ? { hasCustomization: true, html } : { hasCustomization: false });
					},
					error => {
						reject(error);
					}
				);
			}),
		queryKey: [BASE_QUERY_KEY, impersonationContext, type],
	});
}

export const invalidateSchedulerPreviewCustomPageStyleQueries = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
};
